/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-29 14:27
 * @LastEditors: yinping.che@ginlong.com
 * @LastEditTime: 2025-11-14 13:14
 * @FilePath: \glyun_web_vue3_master\src\router\overview.js
 * @Description: 概览路由
 */
export default [
  {
    path: '/overview',
    redirect: '/overview/plantStation',
    name: 'overview',
    component: () => import('../views/nav/index.vue'),
    children: [
      {
        //电站概览
        path: 'plantStation',
        name: 'overviewPlantStation',
        children: [
          {
            //电站概览
            path: '',
            name: 'overviewPlantStation/',
            component: () => import('../views/overview/plantStation/index.vue'),
            meta: {
              title: 'v2_plant_plant_overview',
              // routeAuthCode: 'A0100',
            }
          },
          {
            //电站详情
            path: 'details',
            redirect: '/overview/plantStation/details/overview/:id',
            name: 'overviewPlantStationDetails',
            component: () => import('../views/overview/plantStation/details/index.vue'),
            children: [
              {
                //概况
                path: 'overview/:id',
                name: 'overviewPlantStationDetailsOverview',
                component: () => import('../views/overview/plantStation/details/overview/index.vue'),
                meta: {
                  title: 'v2_plant_details_overview'
                }
              },
              {
                //视图
                path: 'view/:id',
                name: 'overviewPlantStationDetailsView',
                component: () => import('../views/overview/plantStation/details/view/index.vue'),
                meta: {
                  title: 'v2_plant_layout_layout'
                }
              },
              {
                //资料
                path: 'data/:id',
                name: 'overviewPlantStationDetailsData',
                component: () => import('../views/overview/plantStation/details/data/index.vue'),
                meta: {
                  title: 'v2_introduction_label1'
                }
              },
              {
                //设备
                path: 'device/:id',
                name: 'overviewPlantStationDetailsDevice',
                component: () => import('../views/overview/plantStation/details/device/index.vue'),
                meta: {
                  title: 'v2_upgrade_record_device'
                }
              },
              {
                //报警
                path: 'alarm/:id',
                name: 'overviewPlantStationDetailsAlarm',
                component: () => import('../views/overview/plantStation/details/alarm/index.vue'),
                meta: {
                  title: 'v2_plant_alarm'
                }
              },
              {
                //预警信息
                path: 'warning',
                redirect: '/overview/plantStation/details/warning/warningList/:warningType/:id',
                name: 'overviewPlantStationDetailsWarning',
                children: [
                  {
                    //  设备异常离线 || 低效发电电站 || 组串预警
                    path: 'warningList/:warningType/:id',
                    name: 'overviewPlantStationDetailsWarningDeviceAbnormalOffline',
                    component: () =>
                      import(
                        '../views/overview/plantStation/details/warning/warningList/index.vue'
                      ),
                      meta: {
                        title: 'v2_early_warning_warning'
                      }
                  },
                ],
              },
              {
                //设备控制
                path: 'deviceControl/:id',
                name: 'overviewPlantStationDetailsDeviceControl',
                component: () => import('../views/maintenance/deviceControl/index.vue'),
                meta: {
                  title: 'v2_device_control'
                }
              },
              {
                //创建任务
                path: 'createTask/:id',
                name: 'overviewPlantStationDetailsDeviceControlCreateTask',
                component: () => import('../views/maintenance/deviceControl/components/createTask.vue'),
                meta: {
                  title: 'v2_ota_create_tasks'
                }
              },
              {
                //任务详情
                path: 'deviceControlTaskDetail/:taskId/:id',
                name: 'overviewPlantStationDetailsDeviceControlTaskDetail',
                component: () => import('../views/maintenance/deviceControl/components/taskDetail.vue'),
                meta: {
                  title: 'v2_ota_task_details'
                }
              },
            ],
          },
        ],
      },
      {
        //设备概览
        path: 'device',
        name: 'overviewDevice',
        children: [
          {
            //设备概览
            path: '',
            name: 'overviewDevice/',
            component: () => import('../views/overview/device/index.vue'),
            meta: {
              title: 'v2_device_overview',
              routeAuthCode: 'A0101'
            }
          },
          {
            //设备详情
            path: 'details',
            // redirect: '/overview/device/details/inverter/:id',
            name: 'overviewDeviceDetails',
            component: () => import('../views/overview/device/details/index.vue'),
            children: [
              {
                //逆变器
                path: 'inverter',
                name: 'overviewDeviceDetailsInverter',
                component: () => import('../views/overview/device/details/inverter/deviceInfo.vue'),
                meta: {
                  title: 'v2_inverter_label7'
                }
              },
              {
                //逆变器-黑盒子
                path: 'blackBox',
                name: 'overviewDeviceDetailsInverterBlackBox',
                component: () => import('../views/overview/device/details/inverter/blackBoxView.vue'),
                meta: {
                  title: 'v2_inverter_label7'
                }
              },
              {
                //采集器
                path: 'collector',
                name: 'overviewDeviceDetailsCollector',
                component:() => import('../views/overview/device/details/collector/deviceInfo.vue'),
                meta: {
                      title: 'v2_datalogger_details_datalogger_details'
                }
              },
              {
                //EPM
                path: 'epm',
                name: 'overviewDeviceDetailsEpm',
                component:() => import('../views/overview/device/details/epm/deviceInfo.vue'),
                meta: {
                      title: 'v2_router_label32'
                }
              },
              // {
              //   //逆变器
              //   path: 'inverter',
              //   name: 'overviewDeviceDetailsInverter',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsInverterId',
              //       components: {
              //         default:() => import('../views/overview/device/details/inverter/deviceInfo.vue'),
              //         pageLeftNav:()=> import('../views/overview/device/details/inverter/pageLeftNav.vue'),
              //       },
              //       meta: {
              //         title: 'v2_inverter_label7'
              //       }
              //     },
              //   ],
              // },
              // {
              //   //采集器
              //   path: 'collector',
              //   name: 'overviewDeviceDetailsCollector',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsCollector',
              //       components: {
              //         default: () => import('../views/overview/device/details/collector/deviceInfo.vue'),
              //         pageLeftNav:() => import('../views/overview/device/details/collector/pageLeftNav.vue'),
              //       },
              //       meta: {
              //         title: 'v2_datalogger_details_datalogger_details'
              //       }
              //     },
              //   ],
              // },
              // {
              //   //EPM
              //   path: 'epm',
              //   name: 'overviewDeviceDetailsEpm',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsEpmId',
              //       components: {
              //         default: () => import('../views/overview/device/details/epm/deviceInfo.vue'),
              //         pageLeftNav: () => import('../views/overview/device/details/epm/pageLeftNav.vue')
              //       },
              //       meta: {
              //         title: 'v2_router_label32'
              //       }
              //     },
              //   ],
              // },
              {
                //电站详情-树结构
                path: 'station',
                name: 'overviewDeviceDetailStation',
                children: [
                  {
                    path: ':id',
                    name: 'overviewDeviceDetailStationId',
                    components: {
                      default: () => import('../views/overview/device/details/station/detail.vue'),
                      pageLeftNav: () =>
                        import('../views/overview/device/details/station/pageLeftNav.vue'),
                    },
                  },
                ],
              },
              {
                //气象仪
                path: 'weather',
                name: 'overviewDeviceDetailsWeather',
                  component:() =>
                        import('../views/overview/device/details/weather/deviceInfo.vue'),
                meta: {
                  title: 'v2_meteorograph_meteorographDetails'
                }
              },
              {
                //电表
                path: 'meter',
                name: 'overviewDeviceDetailsMeter',
                component: () =>
                        import('../views/overview/device/details/meter/deviceInfo.vue'),
                meta: {
                  title: 'v2_meter_meterDetails'
                }
              },
              {
                //电池
                path: 'battery',
                name: 'overviewDeviceDetailsBattery',
                component: () =>
                        import('../views/overview/device/details/battery/deviceInfo.vue'),
                meta: {
                  title: 'v2_inverter_details_battery_details'
                }
              },
              {
                //新电池
                path: 'batteryNew',
                name: 'overviewDeviceDetailsBatteryNew',
                component: () =>
                        import('../views/overview/device/details/batteryNew/deviceInfo.vue'),
                meta: {
                  title: 'v2_inverter_details_battery_details'
                }
              },
              // {
              //   //气象仪
              //   path: 'weather',
              //   name: 'overviewDeviceDetailsWeather',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsWeatherId',
              //       component:() =>
              //           import('../views/overview/device/details/weather/deviceInfo.vue'),
              //       meta: {
              //         title: 'v2_meteorograph_meteorographDetails'
              //       }
              //     },
              //   ],
              // },
              // {
              //   //电表
              //   path: 'meter',
              //   name: 'overviewDeviceDetailsMeter',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsMeterId',
              //       components:
              //        {
              //         default: () =>
              //           import('../views/overview/device/details/meter/deviceInfo.vue'),
              //         pageLeftNav: () =>
              //           import('../views/overview/device/details/meter/pageLeftNav.vue'),
              //       }
              //     },
              //   ],
              // },
              // {
              //   //电池
              //   path: 'battery',
              //   name: 'overviewDeviceDetailsBattery',
              //   children: [
              //     {
              //       path: ':id',
              //       name: 'overviewDeviceDetailsBatteryId',
              //       components:
              //        {
              //         default: () =>
              //           import('../views/overview/device/details/battery/deviceInfo.vue'),
              //         pageLeftNav: () =>
              //           import('../views/overview/device/details/battery/pageLeftNav.vue'),
              //       }
              //     },
              //   ],
              // },
            ],
          },
        ],
      },
      {
        //创建电站
        path: 'createStation/:id?',
        name: 'createStation',
        component: () => import('../views/overview/createPowerStation/view.vue'),
        // children: [
        //   {
        //     //电站概览
        //     path: '',
        //     name: 'configurationParameteEntry',
        //     component: () => import('../views/overview/plantStation/index.vue'),
        //     meta: {
        //       title: 'v2_plant_plant_overview',
        //       // routeAuthCode: 'A0100',
        //     }
        //   },
        // ]
      },
      {
        //配置参数
        path: 'configurationParameter',
        name: 'configurationParameter',
        component: () => import('../views/overview/configurationParameter/view.vue'),
        meta: {
          title: 'v2_config_params'
        }
      }
      // {//电站概览
      //   path: 'gridinverter',
      //   component: () => import('../views/overview/equipmentOverview/inverter/components/inverterdetail_GridConnected.vue'),
      // },
      // {//电站概览
      //   path: 'energyinverter',
      //   component: () => import('../views/overview/equipmentOverview/inverter/components/inverterdetail_EnergyStorage.vue'),
      // },
    ],
  },
]
